"use strict";
const buttonSelector = '.js-drip_campaigns_send_test_email';
const formSelector = '.js-drip_campaign_email_settings';
window.up.compiler(buttonSelector, function (button) {
    const url = button.dataset.url;
    const form = document.querySelector(formSelector);
    if (url && form) {
        window.up.on(button, 'click', undefined, function () {
            const formData = new FormData(form);
            // Phoenix includes in the form a hidden field with the request's method.
            // The original form does a PUT, but here we need a POST, so this data needs to be removed.
            formData.delete('_method');
            const options = {
                url,
                params: formData,
                method: 'post',
                failTarget: 'flash-alert, .unpoly_wrapper'
            };
            window.up.navigate('flash-alert, .unpoly_wrapper', options);
        });
    }
});
